import { twMerge } from "tailwind-merge";

export type Props = {
  totalPages: number;
  currentPageIndex: number;
  scrollContainerRef: React.RefObject<HTMLDivElement>;
};

export function PaginationDots({
  totalPages,
  currentPageIndex,
  scrollContainerRef,
}: Props) {
  return (
    <div className="flex justify-center items-center mt-4 gap-2">
      {Array.from({ length: totalPages }).map((_, index) => (
        <button
          key={index}
          className={twMerge(
            "w-2 h-2 rounded-full transition-all duration-100",
            index === currentPageIndex
              ? "bg-brand-50 scale-125"
              : "bg-brand-400 hover:bg-brand-100"
          )}
          onClick={() => {
            const scrollContainer = scrollContainerRef.current;

            if (scrollContainer) {
              const targetScrollLeft = index * scrollContainer.clientWidth;
              scrollContainer.scrollTo({
                left: targetScrollLeft,
                behavior: "smooth",
              });
            }
          }}
          aria-label={`Go to page ${index + 1}`}
        />
      ))}
    </div>
  );
}

export default PaginationDots;
